import { apiGet } from '@/infrastructure/api-client';
import type { ActivityItem } from '@/domain/audit/activity-projection';

export function listActivity(
  limit = 10,
  cursor?: string,
): Promise<{ items: ActivityItem[]; nextCursor: string | null }> {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set('cursor', cursor);
  return apiGet(`/api/activity?${params.toString()}`);
}
